import Axios, { AxiosRequestConfig, AxiosRequestTransformer } from "axios";

// Environment files
export const apiBaseUrl = process.env.REACT_APP_API_HOST || '';
export const ssoRedirectUrl = process.env.REACT_APP_SSO_REDIRECT ||'';
export const ssoLogOffURL = process.env.REACT_APP_SSO_LOGOFF || '';
export const tilmeldmigUrl = process.env.REACT_APP_TILMELDMIG || '';
export const mitFiuUrl = process.env.REACT_APP_MITFIU || '';

export class WebHelper implements AxiosRequestConfig {
    private static webHelper: WebHelper;

    public baseURL: string;
    public headers: any;
    public transformRequest: AxiosRequestTransformer;
    public timeout: number = 100000;
    
    constructor() {                
        this.baseURL = apiBaseUrl
        
        this.transformRequest = (data: any, headers: any) => {
            const serializedData = []
            for (const k in data) {
                if (data[k]) {
                    serializedData.push(`${k}=${encodeURIComponent(data[k])}`)
                }
            }
            return serializedData.join('&')
        }
    }

    public static get Instance(): WebHelper {
        if (this.webHelper == null) {
            this.webHelper = new WebHelper();
        }
        return this.webHelper;
    }
    public getAxiosInstance() {
        return Axios.create(this);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/WebHelper.ts